import NProgress from "nprogress";
import { HRMS_EMPLOYEE_API_URL } from "../../../Constants/baseConstant";
import axiosInstance from "../../../../axiosInstance";
import { toast } from "react-toastify";
import { getUserId, getDomain } from "../../Base/helper/baseFunctions";

export const GetVMPreRegistrationVisitorHelper = async (params) => {
    NProgress.start()
    return await axiosInstance(`/visitors/getVMPreRegistrationVisitor`, {
        method: "POST",
        baseURL: HRMS_EMPLOYEE_API_URL,
        data: {
            domain_name: getDomain(),
        },
    })
        .then((res) => {
            NProgress.done()
            return { message: "Pre-registration visitors retrieved successfully", hasError: false, data: res?.data };
        })
        .catch((err) => {
            NProgress.done()
            return { message: "Unable to retrieve pre-registration visitors", hasError: true, data: err?.response?.data };
        });
};

export const UpsertVMPreRegistrationVisitorHelper = async (params) => {
    toast.dismiss();
    toast.info("Saving...");
    return await axiosInstance(`/visitors/upsertVMPreRegistrationVisitor`, {
        method: "POST",
        baseURL: HRMS_EMPLOYEE_API_URL,
        data: {
            domain_name: getDomain(),
            user_id: getUserId(),
            pre_registration_visitors_pk: params?.pre_registration_visitors_pk || null,
            visitors_name: params?.visitors_name,
            visitors_mobile_no: params?.visitors_mobile_no,
            visited_employee_email: params?.visited_employee_email,
            visitor_reason_fk: params?.visitor_reason_fk,
            visitor_reason_comment: params?.visitor_reason_comment || null,
            id_proof: params?.id_proof || null,
            vehicle_no: params?.vehicle_no || null,
            booking_date: params?.booking_date,
            multiple_org_configuration_pk: params?.multiple_org_configuration_pk || null
        },
    })
        .then((res) => {
            toast.dismiss();
            toast.success(params?.pre_registration_visitors_pk ? "Pre-registration updated successfully" : "Pre-registration added successfully");
            return { message: "Pre-registration saved successfully", hasError: false, data: res?.data };
        })
        .catch((err) => {
            toast.dismiss();
            toast.error(err?.response?.data?.error?.[0]?.message || "Something went wrong");
            return { message: "Unable to save pre-registration", hasError: true, data: err?.response?.data };
        });
};

export const DeleteVMPreRegistrationVisitorHelper = async (params) => {
    toast.dismiss();
    toast.info("Deleting...");
    return await axiosInstance(`/visitors/deleteVMPreRegistrationVisitor`, {
        method: "DELETE",
        baseURL: HRMS_EMPLOYEE_API_URL,
        data: {
            domain_name: getDomain(),
            pre_registration_visitors_pk: params?.pre_registration_visitors_pk,
        },
    })
        .then((res) => {
            toast.dismiss();
            toast.success("Pre-registration deleted successfully");
            return { message: "Pre-registration deleted successfully", hasError: false, data: res?.data };
        })
        .catch((err) => {
            toast.dismiss();
            toast.error(err?.response?.data?.error?.[0]?.message || "Something went wrong");
            return { message: "Unable to delete pre-registration", hasError: true, data: err?.response?.data };
        });
};


// Visitors IN Out transactional record

export const getVMVisitorManagementTransactionsHelper = async (params) => {
    NProgress.start()
    return await axiosInstance(`/visitors/getVMVisitorManagementTransactions`, {
        method: "POST",
        baseURL: HRMS_EMPLOYEE_API_URL,
        data: {
            domain_name: getDomain(),
            user_id: getUserId(),
            visitors_management_pk: params?.visitors_management_pk
        },
    })
        .then((res) => {
            NProgress.done()
            return { message: "Pre-registration visitors retrieved successfully", hasError: false, data: res?.data };
        })
        .catch((err) => {
            NProgress.done()
            return { message: "Unable to retrieve pre-registration visitors", hasError: true, data: err?.response?.data };
        });
};

export const upsertVMVisitorManagementTransactionsrHelper = async (params) => {
    toast.dismiss();
    toast.info("Saving...");
    return await axiosInstance(`/visitors/upsertVMVisitorManagementTransactions`, {
        method: "POST",
        baseURL: HRMS_EMPLOYEE_API_URL,
        data: {
            domain_name: params?.domain || getDomain(),
            user_id: params?.user_id || getUserId(),
            visitors_management_fk: params?.visitors_management_fk,
            timestamp: params?.timestamp,
            type: params?.type,   
        },
    })
        .then((res) => {
            // toast.dismiss();
            // toast.success(params?.pre_registration_visitors_pk ? "Pre-registration updated successfully" : "Pre-registration added successfully");
            return { message: "Pre-registration saved successfully", hasError: false, data: res?.data };
        })
        .catch((err) => {
            // toast.dismiss();
            // toast.error(err?.response?.data?.error?.[0]?.message || "Something went wrong");
            return { message: "Unable to save pre-registration", hasError: true, data: err?.response?.data };
        });
};